// Versão: 1.00
// Data..: 2026-09-24
// Configuração do frontend, lida das variáveis de ambiente do Vite (VITE_*).

export const config = {
  apiUrl: import.meta.env.VITE_API_URL ?? '',
  cognito: {
    userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID ?? '',
    clientId: import.meta.env.VITE_COGNITO_CLIENT_ID ?? '',
  },
};
